export const requestStates = {
  pendiente: {
    name: "Pendiente",
    color: "#FFA500", 
    isSelected: true
  },
  aprobado: {
    name: "Aprobado",
    color: "#28A745", 
    isSelected: true
  },
  cambios: {
    name: "Cambios",
    color: "#17A2B8", 
    isSelected: true
  }
};